import React, { MouseEventHandler, useState } from "react";
import { Button, Col, Input, Row, Space, Spin } from "antd";
import { useDictation } from "../../../../common/useDictation";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import styles from "./UtilizationMeasureModalFooter.module.less";

interface UtilizationMeasureModalFooterProps {
    placeholder?: string;
    onCancel?: MouseEventHandler<HTMLElement>;
    onOk?: (comment?: string) => Promise<void>;
}

export const UtilizationMeasureModalFooter: React.FC<UtilizationMeasureModalFooterProps> = ({
    placeholder = "Type or tell me anything about this product",
    onCancel,
    onOk,
}) => {
    const [loading, setLoading] = useState(false);
    const [inputText, setInputText] = useState("");
    const dictation = useDictation({ onTranscript: setInputText });
    const { listening } = dictation;

    const handleSend = async () => {
        setLoading(true);
        await onOk?.(inputText);
        setInputText("");
        setLoading(false);
    };

    return (
        <>
            <Spin spinning={loading}>
                <Row>
                    <Col flex={1}>
                        <Input
                            size="large"
                            bordered={false}
                            placeholder={placeholder}
                            style={{
                                color: "#C2C9D6",
                            }}
                            value={inputText}
                            onChange={(e) => setInputText(e.target.value)}
                        ></Input>
                    </Col>
                    <Col>
                        <Space>
                            <Button
                                className={`${styles.mic}${
                                    listening ? ` ${styles.listening}` : ""
                                }`}
                                type="link"
                                icon={<SvgIcon name="mic" color="#5AD81D" size={18} />}
                                onClick={dictation.toggle}
                            ></Button>
                        </Space>
                    </Col>
                </Row>
                <div className={styles.actions}>
                    <Button type="link" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button type="primary" onClick={handleSend}>
                        Send
                    </Button>
                </div>
            </Spin>
        </>
    );
};
